module.exports = __webpack_public_path__ + "static/media/AT.7dc19006.svg";